import { render, staticRenderFns } from "./Preventivas.vue?vue&type=template&id=5c56e1a1"
import script from "./Preventivas.vue?vue&type=script&lang=js"
export * from "./Preventivas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports